import { DebugStep } from '@/shared/types/tryIt';

export const flattenSteps = (steps?: DebugStep[] | null): DebugStep[] =>
  (steps ?? []).flatMap((step) => [step, ...flattenSteps(step.sub_steps)]);
